export default "__VITE_ASSET__BPf$WF0r__"